import { Component, ChangeDetectionStrategy } from '@angular/core';

import { DxPopupModule } from 'devextreme-angular/ui/popup';
import { DxButtonModule } from 'devextreme-angular/ui/button';
import notify from 'devextreme/ui/notify';
import { UnexpectedErrorDialogService } from 'src/app/services/error-reporting/unexpected-error-dialog.service';

/**
 * The persistent failure dialog. Deliberately NOT a toast: DevExtreme's notify() auto-dismisses in
 * 3 seconds with unselectable text, which cannot carry a reference a user is expected to quote to
 * IT support. This is also not a "wizard popup" in the sense the Crystal convention warns against
 * (feedback_no_popups.md) -- that convention is about multi-step business flows getting their own
 * route; this is a single, system-level interrupt with one message and one action (dismiss), not a
 * flow with steps.
 */
@Component({
  selector: 'unexpected-error-dialog',
  imports: [DxPopupModule, DxButtonModule],
  templateUrl: './unexpected-error-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./unexpected-error-dialog.component.scss'],
})
export class UnexpectedErrorDialogComponent {
  constructor(public dialog: UnexpectedErrorDialogService) {}

  // dx-popup's visibleChange re-emits on every visible transition, including the one we just
  // pushed in via [visible]="dialog.visible()" when show() flips it to true. Only treat this as a
  // dismissal (e.g. Escape key) when the popup is reporting itself closed -- otherwise show()
  // immediately triggers hide() and the dialog never appears.
  onPopupVisibleChange(visible: boolean): void {
    if (!visible) this.dialog.hide();
  }

  copyReference(): void {
    const ref = this.dialog.reference();
    if (!ref) return;
    navigator.clipboard
      .writeText(ref)
      .then(() => notify('Reference copied', 'success', 1500))
      .catch(() => notify('Could not copy -- select and copy manually', 'warning', 2500));
  }
}
